var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToast } from '@/hoc';
import { PreviousButton } from '@/icons';
import { useEffect, useMemo, useState } from 'react';
import CustomizationCard from '../customization-card';
import CustomNewEditModal from '../customization-modal/index';
import DeleteModal from '../delete-confirmation-modal';
import { PlusIcon } from '../icons';
import { Button, Text } from '../ui';
// import { items } from './mockData';
import useApi from '@/hoc/hooks/useApi';
import StagesListSection from '../stages-list-section';
var ManageCustomization = function (_a) {
    var onBack = _a.onBack, _b = _a.showBackButton, showBackButton = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.headingClassName, headingClassName = _d === void 0 ? '' : _d;
    var _e = useState([]), customizationCards = _e[0], setCustomizationCards = _e[1];
    var _f = useState(false), showDeleteModal = _f[0], setShowDeleteModal = _f[1];
    var _g = useState(), deleteItem = _g[0], setDeleteItem = _g[1];
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var _j = useState('create'), mode = _j[0], setMode = _j[1];
    // const [selectedItem, setSelectedItem] = useState<null | (typeof items)[0]>(null);
    var _k = useState(), selectedItem = _k[0], setSelectedItem = _k[1];
    // Toast
    var showToast = useToast().showToast;
    // Handlers
    // const handleEdit = (item: (typeof items)[0]) => {
    //   setSelectedItem(item);
    //   setMode('edit');
    //   setIsOpen(true);
    // };
    var options = useMemo(function () { return ({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }); }, []);
    var _l = useApi('/flow?include_default=true'), data = _l.data, error = _l.error, loading = _l.loading, fetchData = _l.fetchData, createItem = _l.createItem, deleteFlow = _l.deleteItem, updateItem = _l.updateItem;
    var _m = useState([]), stagesItem = _m[0], setStagesItem = _m[1];
    useEffect(function () {
        fetchData();
    }, [fetchData]);
    useEffect(function () {
        if (data) {
            var mappedData = data.map(function (item) { return ({
                _id: item._id,
                name: item.name,
                description: item.description,
                stages: item.stages,
                stageId: item.stages.length,
                hire_state: item === null || item === void 0 ? void 0 : item.hire_state,
            }); });
            setCustomizationCards(mappedData);
        }
    }, [data]);
    var handleCreate = function () {
        setMode('create');
        setIsOpen(true);
    };
    var handleEdit = function (item) {
        var _a;
        // Transform stages array into an array of only _id values
        var transformedItem = __assign(__assign({}, item), { stageId: ((_a = item.stages) !== null && _a !== void 0 ? _a : []).map(function (stage) { return stage._id; }) });
        // Remove stages key since we don't need it
        delete transformedItem.stages;
        setSelectedItem(transformedItem);
        setMode('edit');
        setIsOpen(true);
    };
    var handleSave = function (updatedItem) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!(mode === 'edit')) return [3 /*break*/, 2];
                    // ✅ Edit API Call
                    return [4 /*yield*/, updateItem(updatedItem, fetchData)];
                case 1:
                    // ✅ Edit API Call
                    _a.sent();
                    setCustomizationCards(function (prev) {
                        return prev.map(function (item) { return (item._id === updatedItem[0]._id ? updatedItem[0] : item); });
                    });
                    showToast({ message: 'Customization updated successfully', status: 'success' });
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createItem(updatedItem)];
                case 3:
                    response = _a.sent();
                    setCustomizationCards(function (prev) { return __spreadArray(__spreadArray([], prev, true), [__assign(__assign({}, updatedItem[0]), { id: prev.length + 1 })], false); });
                    showToast({ message: 'Customization added successfully', status: 'success' });
                    _a.label = 4;
                case 4:
                    setIsOpen(false);
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error('Error saving customization:', error_1);
                    showToast({ message: 'Failed to save customization', status: 'error' });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (deleteItem) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!deleteItem._id) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteFlow(deleteItem._id)];
                case 1:
                    res = _a.sent();
                    console.log('Delete response:', res);
                    if ((res === null || res === void 0 ? void 0 : res.status) === 'error') {
                        setShowDeleteModal(false);
                        showToast({ message: res.message, status: 'error' });
                        return [2 /*return*/];
                    }
                    setCustomizationCards(function (prev) { return prev.filter(function (item) { return item._id !== deleteItem._id; }); });
                    setShowDeleteModal(false);
                    showToast({ message: 'Customization deleted successfully', status: 'success' });
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error deleting customization:', error_2);
                    showToast({ message: 'Failed to delete customization', status: 'error' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "p-4 ".concat(className), children: [_jsxs("div", { className: "flex flex-col md:flex-row items-start justify-between mb-6 ".concat(headingClassName), children: [_jsxs("div", { className: 'flex items-center gap-2', children: [!showBackButton && (_jsx(Button, { onClick: onBack, variant: 'text', className: 'text-sm px-0 py-1 md:text-base md:px-4 md:py-2', children: _jsx(PreviousButton, {}) })), _jsx(Text, { variant: 'heading', children: "Manage Customization" })] }), _jsxs(Button, { onClick: handleCreate, variant: 'primary', className: 'flex gap-2', children: [_jsx(PlusIcon, {}), "Add new Customization"] })] }), loading ? (_jsx("div", { className: 'grid grid-cols-4 md:grid-cols-2 gap-6', children: __spreadArray([], Array(4), true).map(function (_, index) { return (_jsxs("div", { className: 'p-6 bg-white rounded-xl border border-vjwSecondary shadow-sm animate-pulse space-y-4', children: [_jsxs("div", { className: 'flex justify-between items-start', children: [_jsx("div", { className: 'h-4 w-40 bg-gray-300 rounded' }), _jsxs("div", { className: 'flex space-x-2', children: [_jsx("div", { className: 'h-6 w-6 bg-gray-300 rounded' }), _jsx("div", { className: 'h-6 w-6 bg-gray-300 rounded' })] })] }), _jsxs("div", { className: 'space-y-2', children: [_jsx("div", { className: 'h-3 w-full bg-gray-200 rounded' }), _jsx("div", { className: 'h-3 w-5/6 bg-gray-200 rounded' }), _jsx("div", { className: 'h-3 w-4/6 bg-gray-200 rounded' }), _jsx("div", { className: 'h-3 w-3/6 bg-gray-200 rounded' }), _jsx("div", { className: 'h-3 w-5/6 bg-gray-200 rounded' }), _jsx("div", { className: 'h-3 w-2/6 bg-gray-200 rounded' })] }), _jsx("div", { className: 'h-4 w-24 bg-gray-300 rounded mt-2' })] }, index)); }) })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: 'grid grid-cols-1 sm:grid-cols-2 lg:gr\nid-cols-3 gap-4', children: customizationCards.length == 0 ? (_jsx("div", { className: 'px-[20px] ', children: _jsx("p", { children: "Click on \"Add Customization\" button to add new Flow" }) })) : (customizationCards.map(function (item) {
                            var _a;
                            return (_jsx(CustomizationCard, { title: item.name, description: item.description, stagesCount: ((_a = item === null || item === void 0 ? void 0 : item.stages) === null || _a === void 0 ? void 0 : _a.length) || 0, onEdit: function () { return handleEdit(item); }, onDelete: function () {
                                    setShowDeleteModal(true);
                                    setDeleteItem(item);
                                }, onView: function () {
                                    setStagesItem(item.stages || []);
                                    setIsOpen(true);
                                    setMode("view");
                                } }, item._id));
                        })) }), showDeleteModal && (_jsx(DeleteModal, { onConfirm: function () { return handleDelete(deleteItem); }, onClose: function () { return setShowDeleteModal(false); }, title: 'Are you sure?', subTitle: 'You want to delete this customization.', positiveCtaText: 'Yes', negativeCtaText: 'No' })), mode === 'view' ? (_jsx(StagesListSection, { isOpen: isOpen, mode: mode, selectedItem: selectedItem, onClose: function () {
                            setIsOpen(false);
                            // setMode('');
                        }, onSave: handleSave, stagesItem: stagesItem })) : (_jsx(CustomNewEditModal, { isOpen: isOpen, mode: mode, selectedItem: selectedItem, onClose: function () { return setIsOpen(false); }, onSave: handleSave }))] }))] }));
};
export default ManageCustomization;
